import { CLOUD_LAUNCH_PROMO } from '@/data/cloud';
const en = {
  m000: "Introducing GizmoSQL for Power BI Users",
  m001: "A live walkthrough of connecting Microsoft Power BI to GizmoSQL via our new custom connector — build interactive dashboards powered by Arrow Flight SQL.",
  m002: "Tue, May 12, 2026 · 3:00 PM GMT-3 (2:00 PM EDT)",
  m003: "Online",
  m004: "Gustavo Leo & Philip Moore — hosted by Fabricent & GizmoData",
  m005: "IoT Tech Expo North America — Visit Our Booth",
  m006: "GizmoData is exhibiting at IoT Tech Expo North America. Stop by our booth to chat about GizmoSQL, GizmoEdge, and running DuckDB-powered analytics at the edge — across 8,000+ professionals and 250+ speakers covering IoT, Edge AI, and digital twins.",
  m007: "Mon–Tue, May 18–19, 2026",
  m008: "San Jose McEnery Convention Center, San Jose, CA",
  m009: "GizmoData Team",
  m010: "MotherDuck + DuckDB May Meetup",
  m011: "GizmoData founder Philip Moore presents \"GizmoSQL: DuckDB, Anywhere You Want It\" at the SF meetup hosted by MotherDuck, with talks from Jacob Matson, Kyle Cheung, and co-host Greybeam.",
  m012: "Thu, May 21, 2026 · 6:00–8:30 PM PDT",
  m013: "San Francisco, CA",
  m014: "Philip Moore",
  m015: "Upcoming Events",
  m016: "Catch Us Live",
  m017: "Join us at upcoming meetups, webinars, and conferences",
  m018: "Event",
  m019: "Register",
};
export type Messages = typeof en;
export const messages = { en, 'pt-BR': {
  m000: "Apresentação do GizmoSQL para usuários de Power BI",
  m001: "Uma demonstração ao vivo da conexão do Microsoft Power BI ao GizmoSQL com nosso novo conector personalizado — crie dashboards interativos com Arrow Flight SQL.",
  m002: "Terça, 12 de maio de 2026 · 15h GMT-3 (14h EDT)",
  m003: "Online",
  m004: "Gustavo Leo e Philip Moore — realização: Fabricent e GizmoData",
  m005: "IoT Tech Expo North America — visite nosso estande",
  m006: "A GizmoData participa como expositora da IoT Tech Expo North America. Visite nosso estande para conversar sobre GizmoSQL, GizmoEdge e análise de dados com DuckDB na borda — em um evento com mais de 8.000 profissionais e mais de 250 palestrantes sobre IoT, IA de borda e gêmeos digitais.",
  m007: "Segunda e terça, 18 e 19 de maio de 2026",
  m008: "San Jose McEnery Convention Center, San Jose, Califórnia",
  m009: "Equipe GizmoData",
  m010: "Meetup de maio MotherDuck + DuckDB",
  m011: "Philip Moore, fundador da GizmoData, apresenta \"GizmoSQL: DuckDB, onde você quiser\" no meetup de São Francisco realizado pela MotherDuck, com palestras de Jacob Matson, Kyle Cheung e da coorganizadora Greybeam.",
  m012: "Quinta, 21 de maio de 2026 · 18h às 20h30 PDT",
  m013: "São Francisco, Califórnia",
  m014: "Philip Moore",
  m015: "Próximos eventos",
  m016: "Encontre-nos ao vivo",
  m017: "Participe dos próximos meetups, webinars e conferências",
  m018: "Evento",
  m019: "Inscreva-se",
} satisfies Messages };
